import { ImageBlobReduceStatic } from 'image-blob-reduce';
import p from 'image-blob-reduce';

const pica = (p as ImageBlobReduceStatic)();

export const resizeFile = (file: File, size: number) =>
  pica
    .toBlob(file, { max: size })
    .then((result) => new File([result], file.name, { type: file.type }));
